/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Card_Employment_TypeInputs */

const en_job_card_employment_type = /** @type {(inputs: Job_Card_Employment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment Type`)
};

const de_job_card_employment_type = /** @type {(inputs: Job_Card_Employment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstellungsart`)
};

/**
* | output |
* | --- |
* | "Employment Type" |
*
* @param {Job_Card_Employment_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_card_employment_type = /** @type {((inputs?: Job_Card_Employment_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Card_Employment_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_card_employment_type(inputs)
	return en_job_card_employment_type(inputs)
});